import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    //this is just a wrapper to be able to mock location.host in tests.
    get host(): string {
        return location?.host || '';
    }

    reload(): void {
        location.reload();
    }
}
